import Vue from 'vue';
import VueIntercom from 'vue-intercom';

export default ({ app }) => {
  Vue.use(VueIntercom, { appId: app.$config.intercomAppId });
};
